import './style.scss';

type IconColor = 'red' | 'blue' | 'error' | 'warning' | 'success';

interface IProps {
  children?: React.ReactNode;
  className?: string;
  color?: IconColor;
}

function Icon(props: IProps) {
  return <span className={propsToClassName(props)}>{props.children}</span>;
}

function propsToClassName(props: IProps): string {
  const parts: (string | null)[] = ['icon-lnH1a'];
  parts.push(colorToClassName(props.color));
  parts.push(props.className ?? null);
  return parts.filter((x) => x != null).join(' ');
}

function colorToClassName(input: IconColor | null | undefined): string | null {
  if (input === 'blue') {
    return 'i-c-blue-anHas';
  }

  if (input === 'red') {
    return 'i-c-red-Nala1';
  }

  if (input === 'error') {
    return 'i-c-err-EM9j';
  }

  if (input === 'warning') {
    return 'i-c-wrn-sqXh';
  }

  if (input === 'success') {
    return 'i-c-suc-O3ES';
  }

  return null;
}

export default Icon;
